import { StatToColor, TypeToColor } from "./consts.js";

var pageChanging = false;
var currPage = 0;

var pageTitles = [
	"Battle AI",
	"Switch AI",
	"Extended Rules",
];

$(window).on("load", function () {
	currPage = parseInt(localStorage.getItem("AIPage") ?? "0");
	$(`#title`).text(pageTitles[currPage]);
	$(`[data-page=${currPage}]`).css({
		display: "flex"
	});

	$(".pageLeft").on("click", () => ChangePage(false));
	$(".pageRight").on("click", () => ChangePage(true));

	$(window).on("keyup", function (e) {
		if (pageChanging) return;

		if (e.key == "ArrowLeft")
			ChangePage(false);
		else if (e.key == "ArrowRight")
			ChangePage(true);
	});

	$(".jump").on("click", function () {
		if (pageChanging) return;
		pageChanging = true;

		let jumpPage = $(this).data("jump-page");
		let jumpTag = $(this).data("jump-tag");

		$(`#title`).css("opacity", 0);
		$(`[data-page=${currPage}]`).fadeOut(250, () => JumpToTag(jumpPage, jumpTag));
	});

	ColorKeywords();
});

function ChangePage(pageRight: boolean) {
	if (pageChanging) return;

	pageChanging = true;
	$(`#title`).css("opacity", 0);

	$(`[data-page=${currPage}]`).fadeOut(250, () => GetNewPage(currPage, pageRight));
}

function GetNewPage(pageNum: number, pageRight: boolean) {
	if (pageRight)	pageNum++;
	else						pageNum--;

	if (pageNum < 0 ) pageNum += pageTitles.length;
	pageNum = pageNum % pageTitles.length;

	$(`#title`).text(pageTitles[pageNum]);
	$(`#title`).css("opacity", 100);

	$(`[data-page=${pageNum}]`).fadeIn(250).css("display", "flex");

	currPage = pageNum;
	localStorage.setItem("AIPage", String(currPage));
	pageChanging = false;
}

function JumpToTag(jumpPage: number, jumpTag: string) {
	$(`#title`).text(pageTitles[jumpPage]);
	$(`#title`).css("opacity", 100);

	$(`[data-page=${jumpPage}]`).fadeIn(250).css("display", "flex");

	if (jumpTag != "no-tag") {
		let jqTag: JQuery = $(`[data-tag=${jumpTag}]`);
		if (jqTag.length == 0)
			throw new Error(`Unable to find Jump Tag: ${jumpTag}`);

		$("html, body").animate({
			scrollTop: jqTag.offset()!.top
		}, 250);
	}
	else {
		$("html, body").animate({
			scrollTop: 0
		}, 250);
	}

	currPage = jumpPage;
	localStorage.setItem("AIPage", String(currPage));
	pageChanging = false;
}

function ColorKeywords() {
	let colorRanges: Record<string, Array<Range>> = {
		Number: [],
		Normal: [],
		Fire: [],
		Water: [],
		Electric: [],
		Grass: [],
		Ice: [],
		Fighting: [],
		Ground: [],
		Poison: [],
		Flying: [],
		Psychic: [],
		Bug: [],
		Rock: [],
		Ghost: [],
		Dragon: [],
		Steel: [],
		Dark: [],
		Fairy: [],
		HP: [],
		Atk: [],
		Def: [],
		SpA: [],
		SpD: [],
		Spe: [],
		Buff: [],
		Nerf: [],
	};

	$("p, li, h6").each((_, el) => {
		const textNodes = Array.from(el.childNodes).filter(node => node.nodeType == Node.TEXT_NODE);
		
		textNodes.forEach(node => {
			let text = node.textContent!;

			Object.keys(colorRanges).forEach(keyword => {
				let searchTerms = [keyword];

				if (keyword == "Buff") {
					searchTerms = [];
					searchTerms.push("faster");
					searchTerms.push("Faster");
					searchTerms.push(">");
					searchTerms.push(">=");
					searchTerms.push("Minor Increase");
					searchTerms.push("Major Increase");
				}
				else if (keyword == "Nerf") {
					searchTerms = [];
					searchTerms.push("slower");
					searchTerms.push("Slower");
					searchTerms.push("<");
					searchTerms.push("<=");
					searchTerms.push("Minor Decrease");
					searchTerms.push("Major Decrease");
				}

				else if (keyword == "Bug") {
					searchTerms.push("Sticky Web");
				}
				else if (keyword == "Dark") {
					searchTerms.push("sleep");
					searchTerms.push("Sleep");
					searchTerms.push("asleep");
					searchTerms.push("Twilight Terrain");
					searchTerms.push("Twilight Surge");
				}
				else if (keyword == "Electric") {
					searchTerms.push("paralyz");
					searchTerms.push("Paralyz");
					searchTerms.push("paralysis");
					searchTerms.push("Electric Terrain");
					searchTerms.push("Electric Surge");
				}
				else if (keyword == "Fairy") {
					searchTerms.push("Misty Terrain");
					searchTerms.push("Misty Surge");
				}
				else if (keyword == "Fire") {
					searchTerms.push("burn");
					searchTerms.push("Burn");
					searchTerms.push("Sun");
					searchTerms.push("Harsh Sunlight");
					searchTerms.push("Drought");
				}
				else if (keyword == "Ghost") {
					searchTerms.push("Curse");
				}
				else if (keyword == "Grass") {
					searchTerms.push("Grassy Terrain");
					searchTerms.push("Grassy Surge");
					searchTerms.push("Leech Seed");
				}
				else if (keyword == "Ground") {
					searchTerms.push("Spikes");
				}
				else if (keyword == "Ice") {
					searchTerms.push("Hail");
					searchTerms.push("Snow Warning");
				}
				else if (keyword == "Normal") {
					searchTerms.push("Flinch");
					searchTerms.push("(Swagger)");
					searchTerms.push("(Flatter)");
				}
				else if (keyword == "Poison") {
					searchTerms.push("Toxic Spikes");
				}
				else if (keyword == "Psychic") {
					searchTerms.push("Fatigue");
					searchTerms.push("Confus");
					searchTerms.push("Psychic Terrain");
					searchTerms.push("Psychic Surge");
					searchTerms.push("Reflect");
					searchTerms.push("Light Screen");
					searchTerms.push("Trick Room");
					searchTerms.push("(Reflect)");
					searchTerms.push("(Light Screen)");
				}
				else if (keyword == "Rock") {
					searchTerms.push("Sandstorm");
					searchTerms.push("Sand Stream");
					searchTerms.push("Stealth Rock");
				}
				else if (keyword == "Water") {
					searchTerms.push("Rain");
					searchTerms.push("Drizzle");
				}

				else if (keyword == "Atk") {
					searchTerms.push("Attack");
					searchTerms.push("(Atk)");
				}
				else if (keyword == "Def") {
					searchTerms.push("Defense");
					searchTerms.push("(Def)");
				}
				else if (keyword == "SpA") {
					searchTerms.push("Special Attack");
					searchTerms.push("(SpA)");
				}
				else if (keyword == "SpD") {
					searchTerms.push("Special Defense");
					searchTerms.push("(Double Battle)");
					searchTerms.push("(SpD)");
				}
				else if (keyword == "Spe") {
					searchTerms.push("(Spe)");
					searchTerms.push("(Non-Spe)");
				}

				searchTerms.forEach(term => {
					let regex, match;
					if (term == "Number")
						regex = new RegExp(/[+-]?\d+(?:\.\d+)?(?:\s*→\s*)?\d*(?:\.\d+)?(?:[stndrth]+|[%x]?)/, "g");
					else if (term == "<" || term == "<=" || term == ">" || term == ">=") {
						regex = new RegExp(`${term}\\d+%?`, "g");
					}
					else {
						const startBoundary = /^\w/.test(term) ? "\\b" : "";
						const endBoundary = /\w$/.test(term) ? "\\b" : "";

						const escapedTerm = term.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");

						regex = new RegExp(`${startBoundary}${escapedTerm}(?:ed|ing|ion|e)*${endBoundary}`, "g");
					}

					while ((match = regex.exec(text)) != null) {
						let range = new Range();
						range.setStart(node, match.index);
						range.setEnd(node, match.index + match[0].length);

						colorRanges[keyword].push(range);

						if (match.index == regex.lastIndex)
							regex.lastIndex++;
					}
				});
			});
		});
	});

	Object.entries(colorRanges).forEach(([keyword, rangeList]) => {
		CSS.highlights.set(keyword, new Highlight(...rangeList));
	});
}